import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './transparencia.css';
import { transparencia_item } from '../../json/transparenciaItem';

const Transparencia = ({name, data}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container transparencia-container container-mh'>
        <div className='row'>
            <div className='col-12'>
                <h1 className='title'>Transparencia</h1>
                <hr className='hr-gob'/>
            </div>
        </div>
        <div className='row'>
            {
                transparencia_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 transparencia_item' >
                        <Link to={ item.transparencia_item_url } rel='noopener noreferrer' className="no-underline">{ item.transparencia_item_nombre }</Link>
                        <hr className='row-separator' />
                    </div>
        
                ))
            }
        </div>
    </div>
  )
}
// Pagina Transparencia
export default Transparencia